import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrustPaymentDigitalWalletPage } from './trust-payment-digital-wallet.page';

const routes: Routes = [
  {
    path: '',
    component: TrustPaymentDigitalWalletPage,
  },
  {
    path: 'redirect',
    component: TrustPaymentDigitalWalletPage, // ✅ allow full reload via redirect
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TrustPaymentDigitalWalletPageRoutingModule {}
